import { motion } from 'framer-motion';
import { formatUsd } from '../../utils/format';

const SwapInputPanel = ({
  label,
  token,
  balance,
  amount,
  usdValue,
  readOnly = false,
  onAmountChange,
  onTokenSelect,
  onPercentClick,
  showQuickAmounts = false,
  isConnected = false
}) => {
  return (
    <div className="lr-split-card lr-input-panel-modern">
      <div className="lr-field-group">
        <div className="lr-field-label-row lr-panel-header">
          <span className="lr-field-label lr-panel-label">{label}</span>
          <span className="lr-field-balance lr-balance-chip">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="5" width="20" height="14" rx="2"/>
              <path d="M2 10h20"/>
            </svg>
            <span>{balance}</span>
          </span>
        </div>

        <div className="lr-token-input-row lr-amount-wrap lr-input-container-modern">
          <button
            className="lr-token-select lr-token-select-modern"
            onClick={onTokenSelect}
            data-press
          >
            <img
              src={token.logo}
              alt={token.symbol}
              className="lr-token-logo lr-token-logo-modern"
              onError={(e) => {
                if (!e.target.dataset.fallback1) {
                  e.target.dataset.fallback1 = 'true';
                  e.target.src = `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/${token.address}/logo.png`;
                } else if (!e.target.dataset.fallback2) {
                  e.target.dataset.fallback2 = 'true';
                  e.target.src = `https://ui-avatars.com/api/?name=${token.symbol}&background=1a1a1a&color=e50914&size=128&bold=true&format=svg`;
                }
              }}
            />
            <span className="lr-token-symbol-modern">{token.symbol}</span>
            <svg className="lr-chevron-modern" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </button>
          
          <div className="lr-amount-group-modern" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <input
              className="lr-input lr-input-amount lr-input-modern"
              type="text"
              inputMode="decimal"
              placeholder="0.0"
              value={amount}
              onChange={onAmountChange}
              readOnly={readOnly}
            />
            <div className="lr-usd-inside lr-usd-value-modern">
              {usdValue ? formatUsd(usdValue) : '$0.00'}
            </div>
          </div>
        </div>

        {showQuickAmounts && isConnected && (
          <div className="lr-balance-actions lr-quick-amounts-modern">
            <motion.button 
              type="button" 
              className="lr-quick-btn"
              onClick={() => onPercentClick(10)} 
              data-press
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              10%
            </motion.button>
            <motion.button 
              type="button" 
              className="lr-quick-btn"
              onClick={() => onPercentClick(25)} 
              data-press
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              25%
            </motion.button>
            <motion.button 
              type="button" 
              className="lr-quick-btn"
              onClick={() => onPercentClick(50)} 
              data-press
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              50%
            </motion.button>
            <motion.button 
              type="button" 
              className="lr-quick-btn lr-quick-btn-max"
              onClick={() => onPercentClick(100)} 
              data-press
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              MAX
            </motion.button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SwapInputPanel;
